import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({providedIn: 'root'})
export class SantoProvider {

  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  constructor(public http: HttpClient) {
  
  }
    
  buscaSantoDia(data: string) {
    return this.http.post<any>(this.baseUrl + '/santo/get-santo-dia', {data : data})
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }
  
}
